import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Http } from '@angular/http';
import { ApiClientService } from '../../../services/api-client.service';
import { ConstantsService } from '../../../services/constants.service';
import { DirectoryService } from '../../../services/directory.service';
import { WebsiteBuilderService } from '../../../services/website-builder.service';
import { DragulaService } from 'ng2-dragula';
import { AuthTokenService } from '../../../services/auth-token.service';
import { WebsitePage } from '../../../types/website-builder/website-page';
import { FileUploadApiService } from '../../../services/api/file-upload-api.service';
import { WebsiteBuilderItemAbout, WebsiteBuilderItemAmenities, WebsiteBuilderItemFeatures, WebsiteBuilderItemGallery, WebsiteBuilderItemWelcome } from '../../../types/website-builder/items';
import { AlertService } from '../../../services/alert.service';
import { IWbThemeColors } from '../../../types/api-response/auth/website-builder';

declare const toastr: any;
declare const swal: any;

@Component({
    selector: 'website-builder-side-editor',
    templateUrl: './website-builder-side-editor.component.html',
    styleUrls: ['./website-builder-side-editor.component.scss']
})

export class WebsiteBuilderSideEditorComponent implements OnInit, OnDestroy {

    disabledFileInput = false;
    navPosition = 'settings';
    attachments: Array<any> = [];
    noEdit = false;
    @Output() public options = { readAs: 'DataURL' };
    togglePresentPart = null;

    websitePage = WebsitePage;

    amenitiesFilterEnabled: boolean;

    @Output() themeChange: EventEmitter<IWbThemeColors> = new EventEmitter();

    /**
     * Theme color settings menu items
     */
    themeColors: Array<{name: string, key: keyof IWbThemeColors}> = [
        {key: 'backgroundColor', name: 'Background Color'},
        {key: 'primaryColor', name: 'Primary Color'},
    ];

    constructor(
      public api: ApiClientService,
      public websiteBuilderService: WebsiteBuilderService,
      public directoryService: DirectoryService,
      private dragulaService: DragulaService,
      private http: Http,
      private authTokenService: AuthTokenService,
      private upload: FileUploadApiService,
      private alert: AlertService
    ) {
    }

    themeChanged() {
        const colors: IWbThemeColors = this.websiteBuilderService.data.data.themeColors;

        colors.textColor = this.isColorLight(colors.backgroundColor) ? '#404040' : '#d3d3d3';
        colors.titleTextColor = this.isColorLight(colors.primaryColor) ? '#404040' : '#d3d3d3';

        this.themeChange.emit(colors);
    }

    private isColorLight(color) {
        const hex = color.replace('#', '');
        const c_r = parseInt(hex.substr(0, 2), 16);
        const c_g = parseInt(hex.substr(2, 2), 16);
        const c_b = parseInt(hex.substr(4, 2), 16);
        const brightness = ((c_r * 299) + (c_g * 587) + (c_b * 114)) / 1000;
        return brightness > 155;
    }

    ngOnInit() {
        this.orderChanged();

        this.dragulaService.setOptions('bag-websiteParts', {
            moves: function (el: any, container: any, handle: any): any {
                return handle.className === 'img-draggable';
            }
        });
        this.dragulaService.drop.subscribe((value) => {
            if(value[4] && value[4].classList && value[4].classList.contains('welcome-slider-li')) {
                this.dragulaService.find('bag-websiteParts').drake.cancel(true);
                toastr.warning(`${this.websiteBuilderService.data.data.websitePages[WebsitePage.welcome].name} element can\'t be moved.`);
            }
        });

        // Rises after model changed
        this.dragulaService.dropModel.subscribe(() => {
            this.orderChanged();
        });

        //Костиль, но не мог решить по другому
        this.togglePresentPart = setInterval(_ => {
            this.websiteBuilderService.data.data.websiteParts.forEach(part => {
                if (part.isDisable && part.isPresent) {
                    part.isPresent = false;
                }
            });
        }, 1000);

        this.amenitiesFilterEnabled = (this.websiteBuilderService.data.data.websitePages[WebsitePage.amenities] as WebsiteBuilderItemAmenities).amenitiesIds.length > 0;
    }

    /**
     * Amenity select change
     *
     * @param id
     * @param event
     */
    onAmenityChange(id, event) {
        const wbItem = this.websiteBuilderService.data.data.websitePages[WebsitePage.amenities] as WebsiteBuilderItemAmenities;
        const amenityIndex = wbItem.amenitiesIds.indexOf(id);
        if(amenityIndex < 0) {
            console.log('check');
            wbItem.amenitiesIds.push(id);
        } else if (amenityIndex > -1) {

            if(wbItem.amenitiesIds.length === 1) {
                this.alert.toast.error('At least one amenity must be selected');
                event.preventDefault();
                return;
            }

            wbItem.amenitiesIds.splice(amenityIndex, 1);
        }
    }

    /**
     * Is checks is amenity selected
     * @param amenityId
     */
    isAmenityChecked(amenityId) {
        const amenitiesIds = (this.websiteBuilderService.data.data.websitePages[WebsitePage.amenities] as WebsiteBuilderItemAmenities).amenitiesIds;

        if(!this.amenitiesFilterEnabled) {
            return true;
        }

        return amenitiesIds.includes(amenityId);
    }

    /**
     * On/Off amenity filter
     */
    amenityFilterToggle() {
        (this.websiteBuilderService.data.data.websitePages[WebsitePage.amenities] as WebsiteBuilderItemAmenities).amenitiesIds = this.amenitiesFilterEnabled ?
            this.websiteBuilderService.data.data.publicAmenities.map(amenity => amenity.id) : [];
    }

    /**
     * Updates page priority properties
     * depends on page keys array items ordering
     */
    private orderChanged() {
        this.websiteBuilderService.data.data.pageKeys.forEach((pageKey, index) => this.websiteBuilderService.data.data.websitePages[pageKey].priority = index + 1);
    }

    onMouseOver(event) {
        if(this.dragulaService.find('bag-websiteParts').drake.dragging)
            this.dragulaService.find('bag-websiteParts').drake.cancel(true);
    }

    addImage(e, itemName) {
        const file = e.target.files[0];
        e.target.value = null;

        if (['.gif', 'jpeg', '.png', '.jpg', '.bmp'].indexOf(file.name.toLowerCase().slice(-4)) === -1) {
            toastr.warning('You can only upload images in .gif, .jpeg, .png, .jpg, .bmp formats');
            return;
        }

        if (file.size > 3000000) {
            toastr.warning('Maximum image size is 3MB.');
            return;
        }

        this.disabledFileInput = true;

        this.upload.fileUpload(file).subscribe(
            document => {
                if (!document.link) {
                    toastr.warning('Image path should not be blank.');
                    return;
                }

                let index = -1;
                this.websiteBuilderService.data.data.websiteParts.filter((part, ind) => {
                    if(part.name == itemName)
                        index =  ind;
                });

                if(itemName == 'logo') {
                    this.websiteBuilderService.data.data.websiteLogo = document.link;
                } else if(itemName == WebsitePage.welcome) {
                    (this.websiteBuilderService.data.data.websitePages[WebsitePage.welcome] as WebsiteBuilderItemWelcome).sliderImage = document.link;
                } else if(itemName === WebsitePage.buildingFeatures) {
                    const buildingFeaturesItem = this.websiteBuilderService.data.data.websitePages[WebsitePage.buildingFeatures] as WebsiteBuilderItemFeatures;
                    const priority = buildingFeaturesItem.buildingFeaturesImages.length + 1;
                    buildingFeaturesItem.buildingFeaturesImages.push({
                        imageUrl: document.link,
                        captionText: '',
                        descriptionText: '',
                        showDescription: true,
                        priority: priority
                    });
                    this.websiteBuilderService.refreshSplittedArray();
                } else if(itemName == WebsitePage.gallery) {
                    const galleryItem = this.websiteBuilderService.data.data.websitePages[WebsitePage.gallery] as WebsiteBuilderItemGallery;
                    const priority = galleryItem.galleryImages.length + 1;
                    galleryItem.galleryImages.push({
                        imageUrl: document.link,
                        captionText: '',
                        priority: priority
                    });
                } else if(itemName == WebsitePage.about) {
                    (this.websiteBuilderService.data.data.websitePages[WebsitePage.about] as WebsiteBuilderItemAbout).imageUrl = document.link;
                }

                toastr.success('Image has been successfully uploaded.');
            },
            error => this.api.errorHandler(error, 'Upload file failed'),
            () => this.disabledFileInput = false
        );
    }

    public fileOver(fileIsOver: boolean, index): void {
        (<any>this.websiteBuilderService.data.data.websiteParts[index]).fileIsOver = fileIsOver;
    }

    public onFileDrop(file, itemName): void {
        file.preventDefault();
        if(file.dataTransfer.files && file.dataTransfer.files.length) {
            for(let i = 0; i < file.dataTransfer.files.length; i++) {
                this.addImage({target: { files: [file.dataTransfer.files[i]] } }, itemName);
            }
        }
    }

    public onFileInput(file, itemName): void {
        file.preventDefault();
        if(file.target.files && file.target.files.length) {
            for(let i = 0; i < file.target.files.length; i++) {
                this.addImage({target: { files: [file.target.files[i]] } }, itemName);
            }
        }
    }

    clickFileInput(index) {
        document.getElementById('fileInput' + index).click();
    }

    removeImage(event, editorLocation, item?, index?): void {
        event.preventDefault();
        swal(
            ConstantsService.getSwalConfig('Warning', 'Do you want to remove image from the list?' ),
            () => {
                if (editorLocation == 'websiteLogo') {
                    this.websiteBuilderService.data.data.websiteLogo = '';
                } else if (editorLocation == 'pages') {
                    if (item instanceof WebsiteBuilderItemGallery) {
                        item.galleryImages.splice(index, 1);
                    } else if (item instanceof WebsiteBuilderItemFeatures) {
                        item.buildingFeaturesImages.splice(index, 1);
                        this.websiteBuilderService.refreshSplittedArray();
                    }
                }
            }
        );
    }

    getAddress(address, item): void {
        const url = `${ConstantsService.googleMapsApi}geocode/json?address=${address}&key=${ConstantsService.googleMapsApiKey}`;
        this.http.get(url).subscribe(
                response => {
                    const body = JSON.parse((<any>response)._body);
                    item.lat = body.results[0].geometry.location.lat;
                    item.changedLat = body.results[0].geometry.location.lat;
                    item.lng = body.results[0].geometry.location.lng;
                    item.changedLng = body.results[0].geometry.location.lng;
                    this.websiteBuilderService.onAddressChange.emit();
                },
            error => this.api.errorHandler(error, 'Failed to get addresss data from Google Maps API.')
        );
    }

    toggleStreetView(value) {
        this.websiteBuilderService.toggleStreetView.emit(value);
    }

    addOfficeHoursRow(hours): void {
        hours.push('');
    }

    removeOfficeHoursRow(hours, index): void {
        if(hours.length > 1)
            hours.splice(index, 1);
        else
            hours[0] = '';
    }

    trackByFn(index, item) {
        return index; // or item.id
    }

    turnFullscreenModeOn() {
        this.websiteBuilderService.fullScreenPreview = true;
       try {
           (<any>document.getElementsByClassName('navbar-static-top')[0]).style.display = 'none';
           (<any>document.getElementsByClassName('sidebar-menu')[0]).style.display = 'none';
           (<any>document.getElementsByClassName('zEWidget-launcher')[0]).style.display = 'none';
       } catch (e) {
           console.log(e);
       }
    }

    ngOnDestroy() {
        this.dragulaService.destroy('bag-websiteParts');
        clearInterval(this.togglePresentPart);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/website-builder/website-builder-side-editor/website-builder-side-editor.component.ts